import React, { useEffect, useState } from "react";
import PrivateHeader from "../../Layouts/PrivateRouteLayouts/PrivateHeader";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import DashBoardSidebar from "./DashBoardSidebar";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import PostNotFound from "../../CustomComponents/AllLoader/PostNotFound";
import { useSelector } from "react-redux";

const DashBoardRoute = ({ children }) => {
  const token = localStorage.getItem("urexperttoken");
  const profile = useSelector(({ profile: { profiledata } }) => profiledata);
  const location = useLocation();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [sidebar, setsidebar] = useState(false);
  const path = "Assets/scss/dashboard.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const pathsToCheck = [
    "dashboard/managework",
    "dashboard/manageteams",
    "dashboard/manageportfolio",
    "dashboard/membership",
    "dashboard/downloads",
    "dashboard/wallet",
    "dashboard/reports",
    "dashboard/downloads",
  ];

  const isCurrentPath = () => {
    return pathsToCheck.some((path) => location.pathname.includes(path));
  };

  if (token) {
    return (
      <>
        <PrivateHeader />
        <div className="col-md-12 dashboard">
          <button className="sidbar-btn " onClick={() => setsidebar(true)}><i class="fa-solid fa-sidebar"></i> Sidebar</button>
          <div className="row">
            <div className={`dashboard-left ${sidebar ? "active" : ""}`}>
              <button className="close-sidebar" onClick={() => setsidebar(false)}><i className="fa-solid fa-xmark"></i></button>
              <DashBoardSidebar setsidebar={setsidebar} />
            </div>
            <div className="dashboard-right">
              {/* {profile?.role_type == 3 || profile?.role_type == 4 ? (
                <>  */}
              {children}
              {/* </>
              ) : isCurrentPath() ? (
                <PostNotFound title={"Please Join As Company / Expert"} />
              ) : (
                <> {children} </>
              )} */}
            </div>
          </div>
        </div>
      </>
    );
  }

  return <Navigate to={`/${lan}/loginwithemail`} />;
};

export default DashBoardRoute;
